/**
 * Landing de marketing — App Saúde
 * Home pública em /. Auth permanece em /login e /register.
 */

import {
  LandingBenefits,
  LandingFooter,
  LandingHeader,
  LandingHero,
  LandingHowItWorks,
  LandingServices,
} from '@/components/landing';

export default function LandingPage() {
  return (
    <div className="min-h-screen bg-white text-neutral-900">
      <LandingHeader />
      <main>
        <LandingHero />
        <LandingServices />
        <LandingHowItWorks />
        <LandingBenefits />
      </main>
      <LandingFooter />
    </div>
  );
}
